import * as React from "react";
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import { Box } from "@chakra-ui/react";

const ScrollArea = React.forwardRef<
  React.ElementRef<typeof ScrollAreaPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Root>
>(({ children, className, ...props }, ref) => (
  <ScrollAreaPrimitive.Root
    ref={ref}
    {...props}
    className={undefined}
  >
    <Box
      position="relative"
      overflow="hidden"
      className={className}
    >
      <ScrollAreaPrimitive.Viewport
        style={{ height: "100%", width: "100%", borderRadius: "inherit" }}
      >
        {children}
      </ScrollAreaPrimitive.Viewport>
      <ScrollBar />
      <ScrollAreaPrimitive.Corner />
    </Box>
  </ScrollAreaPrimitive.Root>
));
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;

const ScrollBar = React.forwardRef<
  React.ElementRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>,
  React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>
>(({ orientation = "vertical", className, ...props }, ref) => {
  const styles = {
    base: {
      display: "flex",
      touchAction: "none",
      userSelect: "none",
      transition: "colors 0.2s",
    },
    vertical: {
      height: "100%",
      width: "10px",
      borderLeft: "1px solid transparent",
      padding: "1px",
    },
    horizontal: {
      height: "10px",
      flexDirection: "column",
      borderTop: "1px solid transparent",
      padding: "1px",
    },
  };

  return (
    <ScrollAreaPrimitive.ScrollAreaScrollbar
      ref={ref}
      orientation={orientation}
      {...props}
      className={undefined}
    >
      {/* @ts-ignore */}
      <Box 
        {...styles.base}
        {...(orientation === "vertical" ? styles.vertical : styles.horizontal)}
        className={className}
      >
        <ScrollAreaPrimitive.ScrollAreaThumb
          style={{
            flex: 1,
            borderRadius: "inherit",
            backgroundColor: "currentColor",
          }}
        />
      </Box>
    </ScrollAreaPrimitive.ScrollAreaScrollbar>
  );
});
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;

export { ScrollArea, ScrollBar };
